import { Component } from '@angular/core';

@Component({
    selector: 'basic-page-header',
    template: `
        <div class="pageHeader">
            <div class="widthLimitedLayout--md">
                <h1>
                    <ng-content select="[page-header-title]"></ng-content>
                </h1>
                <p>
                    <ng-content select="[page-header-description]"></ng-content>
                </p>
            </div>
        </div>
    `,
    standalone: false
})
export class BasicPageHeaderComponent {}
